import { render, staticRenderFns } from "./superuser-search.vue?vue&type=template&id=92bd1d12&"
import script from "./superuser-search.vue?vue&type=script&lang=js&"
export * from "./superuser-search.vue?vue&type=script&lang=js&"
import style0 from "./superuser-search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports